// extracted by mini-css-extract-plugin
export default {"step":"_2we8alSadK","content":"_3luN3m4H-W","title":"_2bpxIBgzN0","vertical":"_1rwHgX5euO","tail":"xGCfSE_PH8","active":"_3-5DoPNr8B","status":"t7c6OnAJQK","current":"_3BAlQp80R5","description":"Tu0203BKan","wait":"_29NiK8mxZ9","success":"_3RC-WFgR-u","transition-failed":"_1yK3zMC5Ol","transitionFailed":"_1yK3zMC5Ol","failure":"_1ec_WSWhUd","label":"ddWtoh9x_s"};
    if(module.hot) {
      // 1622798487413
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  